import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeoLocationService } from '@app/services/geolocation.service';
import { W4formComponent } from '@app/w4-form/w4form.component';
import { RouteGuard } from 'cre-ng';

const routes: Routes = [
  {
    path: 'w4form',
    canActivate: [RouteGuard],
    component: W4formComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [GeoLocationService],
})
export class W4formRoutingModule {}
